module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Bold.342b2969.woff2";